import { Component } from 'vue';

import { UserType } from '~/entities/user';
import {
  IconProfileMd as ProfileIcon,
  IconRefreshMd as RefreshIcon,
  IconMailMd as BroadcastIcon,
  IconPeopleMd as ContactsIcon,
  IconBotSm,
  IconHeartHandshakeSm,
  IconInfoSm,
  IconEnterMd,
} from '@profeat/ui-kit';

export interface MenuItem {
  value: string;
  text: string;
  requiredUserTypes?: UserType[];
  icon?: Component | string;
  indicatorColor?: boolean | string;
  to?: string;
  templateBy?: string;
  href?: string;
  target?: '_self' | '_blank';
}

export const filterMenuByUserType = (
  items: (MenuItem | 'divider')[],
  userType: UserType,
) => {
  const filtered = items.filter((item) => {
    if (item === 'divider') return true;
    if (!item.requiredUserTypes) return true;
    return item.requiredUserTypes.includes(userType);
  });

  return filtered.filter((item, index, array) => {
    if (item !== 'divider') return true;

    if (index === 0) return false;

    if (index === array.length - 1) return false;

    if (array[index + 1] === 'divider') return false;

    return true;
  });
};

export const createMainMenu = (
  t: (key: string) => string,
  hasProfileAlert: boolean,
): (MenuItem | 'divider')[] => [
  {
    value: 'profile',
    icon: ProfileIcon,
    text: t('menu.profile'),
    indicatorColor: hasProfileAlert && 'error',
    to: '/profile',
  },
  {
    value: 'contacts',
    icon: ContactsIcon,
    text: t('menu.customers'),
    to: '/contacts',
  },
  'divider',
  {
    value: 'broadcast',
    icon: BroadcastIcon,
    text: t('menu.mass-mailing'),
    to: '/broadcast',
    requiredUserTypes: [UserType.WAZZUP],
  },
  'divider',
  {
    value: 'trigger-broadcast',
    icon: RefreshIcon,
    text: t('menu.trigger-broadcast'),
    to: '/trigger-broadcast',
    requiredUserTypes: [UserType.WAZZUP],
  },
  'divider',
  {
    value: 'chat-bots',
    icon: IconBotSm,
    text: t('menu.chat-bots'),
    templateBy: 'tag',
    to: '/chat-bots',
    requiredUserTypes: [UserType.WAZZUP],
  },
];

export const createBottomMenu = (
  t: (key: string) => string,
  supportTgLink: string,
): MenuItem[] => [
  {
    value: 'link',
    icon: IconHeartHandshakeSm,
    href: supportTgLink,
    text: t('menu.help'),
    target: '_blank',
  },
  {
    value: 'link',
    icon: IconInfoSm,
    href: 'https://sendbot.yourgood.ru/help',
    text: t('menu.knowledge-db'),
    target: '_blank',
  },
  {
    value: 'logout',
    icon: IconEnterMd,
    text: t('auth.logout'),
  },
];

export const ROUTE_TO_SIDEBAR_MAP = {
  profile: 'profile',
  broadcastSender: 'broadcast',
  contactsUpload: 'contacts',
} as const;

export const SIDEBAR_ITEMS = [
  'profile',
  'contacts',
  'templates',
  'broadcast',
  'trigger-broadcast',
  'chats',
  'chat-bots',
] as const;

export type SidebarItem = (typeof SIDEBAR_ITEMS)[number];
